// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3cVsl","content":"LoadingAlert_content__3ohCb"};